import { signal, effect } from "alien-signals";
import { settingsStore } from "../models/Store.js";
import { settingsKeys } from "../constants.js";

const head = document.querySelector("head");
const meta1 = document.createElement("meta");
meta1.name = "theme-color";
meta1.content = "#000000";
head.appendChild(meta1);
const meta2 = document.createElement("meta");
meta2.name = "theme-color";
meta2.content = "#FFFFFF";
head.appendChild(meta2);

// export function getURLOverrides(href = window.location.href) {
// 	const url = new URL(href);
// 	const overrides = url.searchParams.get("cassisOverrides") || "";
// 	let settings = {};
// 	try {
// 		settings = JSON.parse(overrides);
// 		url.searchParams.delete("cassisOverrides");
// 		window.history.replaceState({}, "", url.toString());
// 	} catch (_err) {
// 		console.error(_err);
// 	}
// 	return settings;
// }

// export const settingsConfig = { overrides: getURLOverrides() };

export const uiTheme = signal(
	settingsStore.getKeySync(settingsKeys.SELECTED_THEME_KEY) || "auto",
);

effect(() => {
	const themeName = uiTheme();
	if (themeName === "night") {
		meta1.removeAttribute("media");
		// head.appendChild(meta1);
		try {
			head.removeChild(meta2);
		} catch (err) {
			console.error(err);
		}
		settingsStore.setKeySync(settingsKeys.SELECTED_THEME_KEY, "night");
		document.documentElement.setAttribute("data-cassis-theme", "night");
	} else if (themeName === "day") {
		meta2.removeAttribute("media");
		// head.appendChild(meta2);
		try {
			head.removeChild(meta1);
		} catch (err) {
			console.error(err);
		}
		settingsStore.setKeySync(settingsKeys.SELECTED_THEME_KEY, "day");
		document.documentElement.setAttribute("data-cassis-theme", "day");
	} else {
		meta1.setAttribute("media", "(prefers-color-scheme: dark)");
		meta2.setAttribute("media", "(prefers-color-scheme: light)");
		head.appendChild(meta1);
		head.appendChild(meta2);
		settingsStore.setKeySync(settingsKeys.SELECTED_THEME_KEY, "auto");
		document.documentElement.setAttribute("data-cassis-theme", "auto");
	}
});
